import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _LightTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { LightTheme5_2 } from "../LightTheme5_2";
export var LightTheme5_3 = createTheme({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_3() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_3, _BasicThemeClassForEx);
    return LightTheme5_3;
  }(BasicThemeClassForExtension), _LightTheme5_.miniModalDescriptionFontSize = '16px', _LightTheme5_.miniModalDescriptionLineHeight = '22px', _LightTheme5_),
  prototypeTheme: LightTheme5_2,
  themeMarkers: [markThemeVersion('5.3')]
});